import LineString from 'ol/geom/LineString';

export class Line extends LineString {

  // @Override
  clone () {
    return lineGeometryFunction(this.flatCoordinates.slice());
  }

}

// Creates a line geometry from coordinates.
export function lineGeometryFunction (coordinates, geometry) {
  if (geometry) {
    geometry.setCoordinates(coordinates);
    return geometry;
  } else {
    return new Line(coordinates);
  }
}
